(ns practitest.frontend.components.number-input
  (:require [practitest.frontend.common.dom :as dom]
            [practitest.frontend.components.overlay :as overlay]
            [practitest.frontend.components.react-bootstrap :as react-bootstrap]
            [reagent.core :as reagent]
            [clojure.string :as str]
            [practitest.frontend.common.format-utils :as fu]))

;; TODO: tooltip error messages
;; TODO: floating numbers support
;; TODO: on-change on enter/on-blur only ?
(defn number-input
  [initial-props]
  (let [local-state (reagent/atom {:error? false
                                   :value  (:value initial-props)})
        input-ref (atom nil)]
    (fn [{:keys [allow-nil?
                 autofocus?
                 on-change]
          :as   props}]
      (let [local-value (:value @local-state)
            error (:error? @local-state)
            class (:class props)
            style (:style props)]

        [:<>
         [:input.form-control
          {:type      "number"
           :ref       (fn [ref]
                        (when (and autofocus? ref)
                          (.focus ref))
                        (reset! input-ref ref))
           :class     (dom/classes-pairs
                        :is-invalid error
                        class true)
           :style     style
           :value     (str (or local-value ""))
           :on-change (fn [e]
                        (let [value (dom/event-value e)]
                          (swap! local-state assoc :value value)

                          (if (and (str/blank? value)
                                   allow-nil?)
                            (do
                              (swap! local-state assoc :error? false)
                              (on-change nil))

                            (if-let [number (fu/try-parse-number value)]
                              (do
                                (swap! local-state assoc :error? false)
                                (on-change number))

                              ;; Show tooltip
                              (swap! local-state assoc :error? true)))))}]
         (when error
           [:div.invalid-feedback
            "Please enter valid number"])]))))
